export enum TypeOTPEnum {
  EMAIL = 'email',
  SMS = 'sms',
  APP = 'app',
}

export enum OtpScenario {
  CHANGE_USER_EMAIL = 'change_user_email',
  CHANGE_USER_PHONE_NUMBER = 'change_user_phone_number',
  VERIFY_EMAIL = 'verify_email',
  VERIFY_USER_PHONE_NUMBER = 'verify_user_phone_number',
  RESET_USER_PASSWORD = 'reset_user_password',
  USER_WITHDRAW = 'user_withdraw',
  REGISTER_USER = 'register_user',
}

export type TTypeOTP = TypeOTPEnum;
